<div>
  <p class="text-fileName">{{fileName}} のダウンロードが行われました。</p>
  <app-file-list
  [originFileNameList]="originFileNameList"
></app-file-list>
</div>
<div class="download-container">
  @if (isDownloading && showProgressIndicator) {
    <div class="loading-content">
      <mat-spinner diameter="50"></mat-spinner>
      <h3>{{ downloadStatus }}</h3>

      @if (downloadProgress > 0) {
        <mat-progress-bar
          mode="determinate"
          [value]="downloadProgress"
          class="progress-bar">
        </mat-progress-bar>
        <p class="progress-text">{{ downloadProgress }}% 完了</p>
      } @else {
        <mat-progress-bar mode="indeterminate" class="progress-bar"></mat-progress-bar>
      }
    </div>
  } @else if (isDownloading && !showProgressIndicator) {
    <!-- 軽いファイルの場合はシンプル表示 -->
    <div class="simple-loading">
      <h3>{{ downloadStatus }}</h3>
      <p>ダウンロードを開始しています...</p>
    </div>
  } @else {
    <div class="completed-content">
      <h3>{{ downloadStatus }}</h3>
      <p>{{resultText}}</p>
    </div>
  }
</div>
